import { getAuth } from 'firebase/auth';

// Get the Firebase Auth instance from the app
import { app } from './firebase';

const auth = getAuth(app);

export { auth }; // Export the Firebase Auth instance for use in other parts of your app
